export default __webpack_public_path__ + "static/media/glitch07.f89b53d9.png";